/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReferralLedgerEntryTypeEnum,
    ReferralLedgerEntryTypeEnumFromJSON,
    ReferralLedgerEntryTypeEnumFromJSONTyped,
    ReferralLedgerEntryTypeEnumToJSON,
} from './ReferralLedgerEntryTypeEnum';

/**
 * 
 * @export
 * @interface ReferralLedgerEntryDto
 */
export interface ReferralLedgerEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralLedgerEntryDto
     */
    id: string;
    /**
     * 
     * @type {ReferralLedgerEntryTypeEnum}
     * @memberof ReferralLedgerEntryDto
     */
    type: ReferralLedgerEntryTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ReferralLedgerEntryDto
     */
    amountCzk: number;
    /**
     * 
     * @type {Date}
     * @memberof ReferralLedgerEntryDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferralLedgerEntryDto
     */
    invitedEmail: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferralLedgerEntryDto
     */
    stripeInvoiceId: string | null;
}

export function ReferralLedgerEntryDtoFromJSON(json: any): ReferralLedgerEntryDto {
    return ReferralLedgerEntryDtoFromJSONTyped(json, false);
}

export function ReferralLedgerEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLedgerEntryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ReferralLedgerEntryTypeEnumFromJSON(json['type']),
        'amountCzk': json['amountCzk'],
        'date': (new Date(json['date'])),
        'invitedEmail': json['invitedEmail'],
        'stripeInvoiceId': json['stripeInvoiceId'],
    };
}

export function ReferralLedgerEntryDtoToJSON(value?: ReferralLedgerEntryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ReferralLedgerEntryTypeEnumToJSON(value.type),
        'amountCzk': value.amountCzk,
        'date': (value.date.toISOString()),
        'invitedEmail': value.invitedEmail,
        'stripeInvoiceId': value.stripeInvoiceId,
    };
}

